import React from 'react';

import type { ColorGroup } from '../types';
import './ColorSelector.css';

interface ColorSelectorProps {
    colorGroups: ColorGroup[];
    selectedColorGroupIdx: number;
    onSelect: (idx: number) => void;
}

export function ColorSelector({ colorGroups, selectedColorGroupIdx, onSelect }: ColorSelectorProps) {
    if (colorGroups.length <= 1) { return null; }

    return (
        <div className="pdp-color">
            <div className="pdp-color__label-row">
                <span className="pdp-color__label">color</span>
            </div>
            <div className="pdp-color__thumbs" role="radiogroup" aria-label="Color">
                {colorGroups.map((group, idx) => {
                    const isActive = idx === selectedColorGroupIdx;
                    return (
                        <button
                            key={idx}
                            type="button"
                            role="radio"
                            aria-checked={isActive}
                            aria-label={group.color || `Color ${idx + 1}`}
                            className={`pdp-color__thumb${isActive ? ' pdp-color__thumb--active' : ''}`}
                            onClick={() => onSelect(idx)}
                        >
                            {group.image_srcsets ? (
                                <picture>
                                    <source srcSet={group.image_srcsets.avif} type="image/avif" />
                                    <source srcSet={group.image_srcsets.webp} type="image/webp" />
                                    <img
                                        src={group.image_url || undefined}
                                        alt={group.color || ''}
                                        loading="lazy"
                                    />
                                </picture>
                            ) : group.image_url ? (
                                <img src={group.image_url} alt={group.color || ''} loading="lazy" />
                            ) : (
                                <span className="pdp-color__thumb-placeholder" aria-hidden="true" />
                            )}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
